import { Rule } from "antd/es/form";

export const EMAIL_FORM_ITEM_RULES: Rule[] = [
  {
    type: "email",
    message: "Please enter a valid email address",
  },
  {
    required: true,
    message: "Please enter your email address",
  },
];
